import templateUrl from './eventTinyLineWithClockComponent.html';

export default {
  templateUrl,
  bindings: {
    iconShown: '<',
  },
  controllerAs: 'ctrl',
  transclude: true,
};
